export default __webpack_public_path__ + "static/media/photo_gallery_1.db23ba53.png";